export default "__VITE_ASSET__B6Ra97oj__"